import type { AboutData } from '@/data/types';

export interface AboutProps {
  content: AboutData;
}

export function About({ content }: AboutProps) {
  return (
    <section className="relative bg-red-600 py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-3 gap-8 lg:gap-12 items-start">
          {/* Text Content - takes up 2 columns */}
          <div className="lg:col-span-2 space-y-6">
            {content.paragraphs.map((paragraph, index) => (
              <p
                key={index}
                className="text-white text-xl leading-relaxed text-center font-medium max-w-none"
              >
                {paragraph}
              </p>
            ))}
          </div>

          {/* Call-to-Action Buttons - takes up 1 column */}
          <div className="lg:col-span-1 flex flex-col space-y-4 justify-center lg:justify-start lg:mt-8">
            <a
              href={content.buttons.bookAppointment.href}
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-red-600 font-semibold rounded-full hover:bg-gray-100 transition-colors duration-200 text-center text-lg w-full max-w-xs mx-auto lg:mx-0"
            >
              {content.buttons.bookAppointment.text}
            </a>
            <a
              href={content.buttons.faq.href}
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-red-600 font-semibold rounded-full hover:bg-gray-100 transition-colors duration-200 text-center text-lg w-full max-w-xs mx-auto lg:mx-0"
            >
              {content.buttons.faq.text}
            </a>
          </div>
        </div>
      </div>

      {/* Decorative curved bottom border */}
      <div className="absolute bottom-0 left-0 w-full">
        <svg
          className="w-full h-12 sm:h-16 lg:h-20"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0,120 Q300,0 600,60 T1200,120 L1200,120 L0,120 Z"
            fill="white"
          />
        </svg>
      </div>
    </section>
  );
}